import React from 'react';
import Head from 'next/head';
import { InterviewNowFromWrapper } from './InterviewNowFromWrapper';

type ContextType = 'link' | 'demo' | 'talk';

type Props = { context: ContextType };

export const InterviewNowPage: React.FC<Props> = ({ context }) => {
  return (
    <>
      <Head>
        <title>
          {context === 'talk' ? 'Vette | Talk Now' : 'Vette | Applicant'}
        </title>
      </Head>
      <InterviewNowFromWrapper isPredemo={context === 'demo'} />
    </>
  );
};
